import React, { CSSProperties } from "react";
import { copyFromElm } from "../../lib/text";
import { LANG_ENG, LANG_URD } from "../../helpers/translate";
import { eventEmitter } from "../../services";
import { translate, EVT_COPY_TRANSLATION, EVT_LTR_TRANSLATED } from "./helpers";

import RTLView from "./RTLView";
import LTRView from "./LTRView";
import { Container, Titles, Divider } from "./styles";

const copyStyle: CSSProperties = {
    position: "absolute",
    left: "-9999px",
};

type Props = {};
type State = {
    loading: boolean;
    src_lang: string;
    dst_lang: string;
    src: string[];
    dst: string[];
};

export default class SplitView extends React.Component<Props, State> {
    private copyElm: React.RefObject<HTMLDivElement>;

    constructor(props: Props) {
        super(props);
        this.state = {
            loading: false,
            src_lang: LANG_ENG,
            dst_lang: LANG_URD,
            src: [],
            dst: [],
        };
        this.copyElm = React.createRef<HTMLDivElement>();
    }

    componentDidMount() {
        eventEmitter.on(EVT_COPY_TRANSLATION, () => {
            if (this.copyElm.current) {
                copyFromElm(this.state.dst.join(""), this.copyElm.current);
            }
        });
    }

    onInput = async (text: string) => {
        await this.fetchTranslations(text);
    };

    async fetchTranslations(text: string) {
        this.setState({ loading: true });
        const { src_lang, dst_lang } = this.state;
        try {
            const res = await translate(text, src_lang, dst_lang);
            if (typeof res === "undefined") {
                this.setState({ loading: false });
                return;
            }

            const { src, dst } = res!;
            this.setState({ src, dst, loading: false });
            eventEmitter.emit(EVT_LTR_TRANSLATED);
        } catch (e) {
            console.warn("fetchTranslations failed");
            console.warn(e);
        }
    }

    updateDst = (index: number, text: string) => {
        const { dst } = this.state;
        dst[index] = text;
        this.setState({ dst: [...dst] });
    };

    render() {
        return (
            <Container>
                <Titles {...this.state} />
                <RTLView {...this.state} update={this.updateDst} />
                <Divider />
                <LTRView src={this.state.src} onInput={this.onInput} />
                <div style={copyStyle} ref={this.copyElm} />
            </Container>
        );
    }
}
